import { EnvironmentInjector, Injectable, TemplateRef, createComponent } from '@angular/core';

import { BetslipBetBuilderPick } from '../../../core/picks/betslip-bet-builder-pick';
import { BetslipPick } from '../../../core/picks/betslip-pick';
import { BetslipUnknownPick } from '../../../core/picks/betslip-unknown-pick';
import { PickType } from '../../../core/picks/pick-models';
import PickDisplayTemplatesComponent from '../components/digital/pick-display-templates.component';

@Injectable()
export default class PickTypeSelectorService {
    constructor(private injector: EnvironmentInjector) {}

    resolve(pick: BetslipPick): [TemplateRef<any>, string] {
        const component = createComponent(PickDisplayTemplatesComponent, { environmentInjector: this.injector });

        if (BetslipUnknownPick.isPick(pick)) {
            return [component.instance.unknownPickTemplate, 'betslip-digital-pick-unknown'];
        }
        switch (pick.id.getPickType()) {
            case PickType.BetBuilderPick:
                if (!BetslipBetBuilderPick.isEntainUiBetBuilderPick(pick)) {
                    return [component.instance.betBuilderPickTemplate, 'betslip-digital-pick-bet-builder precreated'];
                } else {
                    return [component.instance.betBuilderPickTemplate, 'betslip-digital-pick-bet-builder'];
                }
            case PickType.V2ParticipantPick:
                return [component.instance.participantPickTemplate, 'betslip-digital-pick-participant'];
            case PickType.GroupedPicks:
                return [component.instance.groupedPickTemplate, 'betslip-digital-pick-bet-builder'];
            default:
                return [component.instance.optionMarketPickTemplate, 'betslip-digital-pick-option-market'];
        }
    }
}
